import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"info\"><path d=\"M12.455 5.779V3h-2.91v2.779h2.91zm0 13.221V7.82h-2.91V19h2.91z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol